import { useLocation } from "react-router-dom"
import Seo from "./Seo"

// Route prefixes that must never appear in search results.
//
// Kept as one list rather than a <Seo noindex> inside each page because several of
// these pages have multiple return branches (loading / error / success), and patching
// one branch would leave the others indexable. Matching on the path covers every
// branch, and covers all /admin/* and /account/* subroutes automatically.
//
// This mirrors the Disallow rules emitted by scripts/generate-sitemap.js — robots.txt
// stops well-behaved crawlers fetching the URL, while noindex keeps a page that was
// reached some other way (a shared link, an old index entry) out of the results.
const NOINDEX_PREFIXES = [
  "/login",
  "/register",
  "/checkout",
  "/wallet",
  "/account",
  "/admin",
  "/receipt",
  "/security", // password-reset / email-verification action page, not public content
  "/unsubscribe", // token-scoped opt-out link from an email footer
]

export const isNoIndexPath = (pathname) => {
  const path = (pathname || "/").toLowerCase().replace(/\/+$/, "") || "/"
  return NOINDEX_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))
}

/**
 * Emits <meta name="robots" content="noindex, follow"> on private/transactional routes.
 * Mount once, AFTER <Routes>, so it takes precedence over any page-level <Seo>.
 */
const RouteIndexingPolicy = () => {
  const { pathname } = useLocation()
  if (!isNoIndexPath(pathname)) return null
  return <Seo noindex />
}

export default RouteIndexingPolicy
